import angular from 'angular';

import ChartModule from './chart';
import CashFlowChartModule from './cash-flow-chart';
import IncomeExpenseChartModule from './income-expense-chart';
import CategoryChartModule from './category-chart';
import CardModule from './card';
import CardWithPeriodModule from './card-with-period';
import CardWithYearPickerModule from './card-with-year-picker';
import SelectedDateRangeModule from './selected-date-range';

export default angular
    .module('application.scene.authorized.scene.dashboard.component', [
        ChartModule.name,
        CashFlowChartModule.name,
        IncomeExpenseChartModule.name,
        CategoryChartModule.name,
        CardModule.name,
        CardWithPeriodModule.name,
        CardWithYearPickerModule.name,
        SelectedDateRangeModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/index.js